var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectGutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319378",
    clipPath: "url(#clip0_2155_374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 593",
    d: "M6.59912 13.25H0.849121V4.25L4.84912 3.75V7.75H11.3491V3.25L15.3491 2.75V13.25H13.7866",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0614 11.1548L7.10019 9.17062C7.06851 9.16054 7.03395 9.15479 6.9994 9.15479C6.96484 9.15479 6.92884 9.16054 6.89284 9.17062C6.71717 9.22822 6.6207 9.41541 6.6783 9.59684L8.65961 15.5365C8.68409 15.62 8.74025 15.6963 8.82376 15.7409C8.87416 15.7683 8.92887 15.7812 8.98215 15.7812C9.1031 15.7812 9.21974 15.715 9.27733 15.6027L10.1917 13.8618L11.8519 15.5249L11.8706 15.5408C11.9354 15.6056 12.0204 15.6373 12.1068 15.6373C12.1931 15.6373 12.2781 15.6056 12.3429 15.5408L13.0499 14.8309C13.1809 14.6999 13.1809 14.4911 13.0499 14.3586L11.371 12.6826L13.1089 11.7682C13.1852 11.725 13.2428 11.6631 13.2702 11.5753C13.3307 11.3996 13.2328 11.211 13.0614 11.1548ZM10.9419 11.8676L9.91521 12.4075L9.37669 13.4328L9.10454 13.9526L7.92382 10.4147L11.4631 11.5926L10.9419 11.8676Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2155_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectGutter);
export default __webpack_public_path__ + "static/media/select-gutter.29cf602d85747a6bce513225948a2d81.svg";
export { ForwardRef as ReactComponent };